const routes = [
    {
        path: ["/", "/home"],
        exact: true,
        component: "Home",
    },
    {
        path: "/services",
        exact: true,
        component: "Services",
    },
    {
        path: "/services/:slug",
        exact: true,
        component: "ServiceDetail",
    },
    {
        path: "/solutions",
        exact: true,
        component: "Solutions",
    },
    {
        path: "/solutions/:slug",
        exact: true,
        component: "SolutionDetail",
    },
    {
        path: "/contact",
        exact: true,
        component: "Contact",
    },
    {
        path: "/book",
        exact: true,
        component: "BookConsultation",
    },
];

export default routes;
